<template>
    <div class="ask-form-group">
        <b-form-input
            v-model="$v.title.$model"
            :state="checkState('title')"
        ></b-form-input>
        <b-button-group>
            <b-button variant="danger" @click="$emit('cancel')">
                <i class="fa fa-times" aria-hidden="true"></i>
            </b-button>
            <b-button
                variant="primary"
                :disabled="$v.title.$invalid"
                @click="save()"
            >
                <i class="fa fa-check" aria-hidden="true"></i>
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'Form',
    mixins: [validationMixin],
    props: {
        initialTitle: String,
    },
    validations: {
        title: {
            required,
        },
    },
    data() {
        return {
            title: null,
        }
    },
    mounted() {
        this.title = this.initialTitle
    },
    methods: {
        checkState(value) {
            const field = this.$v[value]
            return field.$dirty ? !field.$invalid : null
        },
        save() {
            if (this.$v.title.$invalid) {
                return
            }
            this.$emit('save', this.$v.title.$model)
        },
    },
}
</script>

<style lang="sass" scoped>
.ask-form-group
        background-color: #fff
        width: 100%
        display: flex
        input
            margin-right: 2px
            font-size: 13px
            color: #000
</style>
